<div class="kt-section">
	<div class="kt-section__content">
		<div class="modal-header">
			<h4 class="modal-title">{{productName}}</h4>
			<button type="button" class="close" aria-label="Close" (click)="btnImageClose()">
				<span aria-hidden="true">&times;</span>
			</button>
		</div>
		<div class="modal-body">
			<img class="kt-widget7__img" alt="" width="100%" [src]="imgActualSize">
		</div>
		<div class="modal-footer" style="justify-content: center;">
			<h3>{{productCode}}</h3>
		</div>
	</div>
</div>


